export default __webpack_public_path__ + "assets/4b9b834e819b2e07e4cfb3c7236cf0c7.jpg";